'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarouselBrowserify = require('slick-carousel-browserify');

var _slickCarouselBrowserify2 = _interopRequireDefault(_slickCarouselBrowserify);

var _award = require('../molecules/award.vue');

var _award2 = _interopRequireDefault(_award);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'award': _award2.default
    },
    props: ['awards'],
    ready: function ready() {
        (0, _jquery2.default)('.project-awards-slider').slick({
            dots: true,
            infinite: false,
            centerMode: true,
            centerPadding: '60px',
            arrows: true,
            responsive: [{
                breakpoint: 600,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1
                }
            }]
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<ul class=\"project-awards-slider\">\n    <li v-for=\"award of awards\" class=\"project-awards-slider__item\">\n        <award :award=\"award\">\n        </award>\n    </li>\n</ul>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e5b1949", module.exports)
  } else {
    hotAPI.update("_v-7e5b1949", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}